import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShowElementSharedService {
  private showStickyAddToCart = new BehaviorSubject<boolean>(true);
  showStickyAddToCartOnViewPort = this.showStickyAddToCart.asObservable();

  constructor() {}

  showStickyAddToCartOnPdp(show: boolean) {
    this.showStickyAddToCart.next(show);
  }
}
